import { FCC, JarvisCookieAuthProvider } from "@dgs/core";
import { useFrontendConfig } from "../config/useFrontendConfig";

export const JarvisAuthProvider: FCC = ({ children }) => {
	const { authUrl } = useFrontendConfig();

	return <JarvisCookieAuthProvider authUrl={authUrl}>{children}</JarvisCookieAuthProvider>;
};
